import { Chip } from "@mui/material";
import { Datagrid, DateField, FunctionField, List, TextField } from "react-admin";

import { withdrawalStatus } from "./status";

export function WithdrawalList() {
  return (
    <List perPage={25} sort={{ field: "created_at", order: "DESC" }} exporter={false}>
      <Datagrid bulkActionButtons={false} rowClick="show">
        <TextField source="reference" label="Заявка" sx={{ fontFamily: "monospace" }} />
        <FunctionField
          label="Статус"
          render={(r: { status: string }) => {
            const s = withdrawalStatus(r.status);
            return <Chip size="small" color={s.color} label={s.label} />;
          }}
        />
        <TextField source="method_label" label="Способ" />
        <FunctionField
          label="Источник"
          render={(r: { source_label?: string }) => (
            <Chip size="small" variant="outlined" label={r.source_label ?? "Счёт"} />
          )}
        />
        <FunctionField
          label="Списано ₽"
          render={(r: { amount_rub: number | null }) => (r.amount_rub != null ? r.amount_rub.toLocaleString("ru-RU") : "—")}
        />
        <FunctionField label="К выплате USD" render={(r: { net_usdt: number }) => r.net_usdt.toFixed(2)} />
        <TextField source="user_phone" label="Телефон" />
        <DateField source="created_at" label="Создана" showTime />
      </Datagrid>
    </List>
  );
}
